import { createApp } from 'vue'
import App from './App.vue'
import firebase from 'firebase/compat/app'
import dayjs from "dayjs";
import 'dayjs/locale/ja'
import router from './router'

// dayjsのローカル設定
dayjs.locale('ja')

const config = {
    apiKey: "AIzaSyBPyB57xRIDbhGFEj8SEFhujEYNFL5BBZk",
    authDomain: "space-adce7.firebaseapp.com",
    databaseURL: "https://space-adce7-default-rtdb.firebaseio.com",
    projectId: "space-adce7",
    storageBucket: "space-adce7.appspot.com",
    messagingSenderId: "1013396785869",
    appId: "1:1013396785869:web:ed8a3245e78c246ecd7784"
}
firebase.initializeApp(config)

createApp(App).use(router).mount('#app')
